/** The tallest a diff pane grows to (in pixels); it shrinks to fit shorter content. */
export const defaultHeightPx = 100;

/** The tallest a diff pane grows to (in pixels) once the chat interface is wide. */
export const maxHeightPx = 240;

/**
 * Vertical padding inside each editor. Applied through Monaco rather than CSS so that
 * it is included in getContentHeight(), which drives the height of the pane.
 */
export const editorPaddingPx = 4;

/** The number of context lines to show around changed lines in the diff. */
export const contextLineCount = 1;

/** CSS class for inline removed text highlighting. */
export const removedInlineClass = "diff-removed-inline";

/** CSS class for inline added text highlighting. */
export const addedInlineClass = "diff-added-inline";

/** Test id shared by both editor panes of the highlighted diff. */
export const diffHighlightEditorTestId = "diff-highlight-editor";
